import z from 'zod';
export const SUBSCRIPTION_PLAN_DOKIA_SOLUTION = 'dokia_solution';
export const SUBSCRIPTION_PLAN_DOKIA_CONSEIL = 'dokia_conseil';
export const SUBSCRIPTION_PLAN_DOKIA_FORMATIONS = 'dokia_formations';
export const SUBSCRIPTION_PLAN_SOCIETE = 'societe';
export const SUBSCRIPTION_PLAN_SOCIETE_PLUS = 'societe+';
export const SUBSCRIPTION_PLAN_CCN = 'ccn';
export const subscriptionPlanValue = z.enum([
    SUBSCRIPTION_PLAN_CCN,
    SUBSCRIPTION_PLAN_DOKIA_CONSEIL,
    SUBSCRIPTION_PLAN_DOKIA_FORMATIONS,
    SUBSCRIPTION_PLAN_DOKIA_SOLUTION,
    SUBSCRIPTION_PLAN_SOCIETE,
    SUBSCRIPTION_PLAN_SOCIETE_PLUS,
]);
export const subscriptionPlan = (value) => subscriptionPlanValue.parse(value);
export const isSubscriptionPlan = (value) => subscriptionPlanValue.safeParse(value).success;
export const BILLING_PERIOD_MONTHLY = 'monthly';
export const BILLING_PERIOD_ANNUAL = 'annual';
export const BILLING_PERIOD_DAILY = 'daily';
export const billingPeriodValue = z.enum([
    BILLING_PERIOD_DAILY,
    BILLING_PERIOD_ANNUAL,
    BILLING_PERIOD_MONTHLY,
]);
export const billingPeriod = (value) => billingPeriodValue.parse(value);
export const isBillingPeriod = (value) => billingPeriodValue.safeParse(value).success;
export const FIRM_TYPOLOGY_SMALL = 'small';
export const FIRM_TYPOLOGY_MEDIUM = 'medium';
export const FIRM_TYPOLOGY_LARGE = 'large';
export const firmTypologyValue = z.enum([
    FIRM_TYPOLOGY_LARGE,
    FIRM_TYPOLOGY_MEDIUM,
    FIRM_TYPOLOGY_SMALL,
]);
export const firmTypology = (value) => firmTypologyValue.parse(value);
export const isFirmTypology = (value) => firmTypologyValue.safeParse(value).success;
export const SUBSCRIPTION_PAYMENT_METHOD_SEPA_ONLY = 'sepa_only';
export const SUBSCRIPTION_PAYMENT_METHOD_SEPA_AND_CARD = 'sepa_and_card';
export const subscriptionPaymentMethodValue = z.enum([
    SUBSCRIPTION_PAYMENT_METHOD_SEPA_AND_CARD,
    SUBSCRIPTION_PAYMENT_METHOD_SEPA_ONLY,
]);
export const subscriptionPaymentMethod = (value) => subscriptionPaymentMethodValue.parse(value);
export const isSubscriptionPaymentMethod = (value) => subscriptionPaymentMethodValue.safeParse(value).success;
export { lawType as domain, lawTypeValue as domainValue, isLawType as isDomain, } from '../../shared/lawTypesContants';
//# sourceMappingURL=subscription-enums.js.map